import { cn } from '@/lib/ui-kit/utils';

/** Hover, focus, pressed and picked states shared by every row of the nav panels. */
export const NAV_ROW_STATE_CLASS = cn(
  'outline-none transition-colors',
  'hover:bg-v2-neutral-surface focus-visible:bg-v2-neutral-surface data-[selected]:bg-v2-neutral-surface',
  'dark:hover:bg-white/10 dark:focus-visible:bg-white/10 dark:data-[selected]:bg-white/10',
  'active:bg-black/10 dark:active:bg-white/15',
);

// ── Mega menu market column (Figma 15071:148044, row 14648:43516) ──

export const PAIR_ICON_SIZE = 28;
export const MARKET_ROW_CLASS = cn(
  'flex h-14 w-full shrink-0 items-center gap-3 rounded-[8px] px-3 py-2.5',
  NAV_ROW_STATE_CLASS,
);
// Figma's 3px bar on a white/10 track.
export const MARKET_LIST_CLASS = cn(
  'flex h-[322px] flex-col gap-0.5 overflow-y-auto overflow-x-clip',
  '[&::-webkit-scrollbar]:w-[3px] [&::-webkit-scrollbar-track]:rounded-[2px] [&::-webkit-scrollbar-thumb]:rounded-[2px]',
  '[&::-webkit-scrollbar-track]:bg-v2-border dark:[&::-webkit-scrollbar-track]:bg-white/10',
  '[&::-webkit-scrollbar-thumb]:bg-v2-btn-secondary-hover supports-[-moz-appearance:none]:[scrollbar-width:thin]',
);

// ── Animations (Lottie files from the design team) ──

// The flame is ~170x283 in the middle of a 640x480 canvas; the card frame keeps
// Figma's 20x16 slot (an 18x12 card) out of the 96x80 one.
export const FIRE_LOTTIE_PROPS = { rendererSettings: { viewBoxSize: '230 92 180 296' } };
export const CARD_LOTTIE_PROPS = { rendererSettings: { viewBoxSize: '8 8 80 64' } };
